  //TextFields helpers
  //---------------------------

const emailRegex = /^[^@]+@[^@]+\.[^@]+$/;
const pswRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^\-_=+*().~`,?])[A-Za-z\d@$!%*?&#^\-_=+*().~`,?]{10,40}$/;

export {emailRegex, pswRegex}

  export function onTextFieldChange(e,func,errorFunc,requirement,conditionalWrapper=null){
    console.log(errorFunc)
    if(conditionalWrapper)
    {
      conditionalWrapper(e,func,errorFunc,requirement)
    }
    else
    {
      func(e.target.value)
      errorFunc(!requirement.test(e.target.value))
    }

  }
  //text field input validator functions
  export function onNumOnlyChange(e, func, errorFunc,requirement){
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
       func(e.target.value)
       errorFunc(!requirement.test(e.target.value))
    }
  }
  export function onDateOnlyChange(e, func, errorFunc,requirement){
    const re = /^(1[0-2]|0[1-9]|\d)?\/?(\d){0,2}$/;
    if (e.target.value === '' || re.test(e.target.value)) {
       func(e.target.value)
       errorFunc(!requirement.test(e.target.value))
    }
  }

  export function onCharacterOnlyChange(e, func, errorFunc,requirement){
    const re = /^[a-zA-Z\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
        func(e.target.value)
        errorFunc(!requirement.test(e.target.value))
    }
  }
  //---------------------------